import {
  RouterProvider,
  createBrowserRouter,
  redirect,
} from "react-router-dom";
import checkLogin from "./hooks/useCheckLogin";
import ShowInReportProfessor from "./page/ShowInReportProfessor";
import HomePage from "./page/HomePage";
import Login from "./page/LoginPage";


function App() {
  const getLogin = async () => {
    return await checkLogin();
  };
  const isLoggedIn = async () => {
    if (!(await getLogin())) return redirect("/login");
    return null;
  };
  const isNotLoggedIn = async () => {
    if (await getLogin()) return redirect("/");
    return null;
  };
  const router = createBrowserRouter([
    {
      path: "/",
      loader: isLoggedIn,
      element: <HomePage></HomePage>,
    },
    {
      path: "/login",
      loader: isNotLoggedIn,
      element: <Login />,
    },
    {
      path: "/ShowInReportProfessor",
      loader: isLoggedIn,
      element: <ShowInReportProfessor />,
    }
  ]);
  return <RouterProvider router={router}></RouterProvider>;
}

export default App;
